import { render, staticRenderFns } from "./userAccessMgmtUpdatePassword.vue?vue&type=template&id=9bfee4fa&"
import script from "./userAccessMgmtUpdatePassword.vue?vue&type=script&lang=js&"
export * from "./userAccessMgmtUpdatePassword.vue?vue&type=script&lang=js&"
import style0 from "./userAccessMgmtUpdatePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports